import { campaignConstants } from '../constants';

export const getDefaultCharityByCountryCode = (countryCode) => {
  return campaignConstants.defaultCharityId[countryCode.toLowerCase()] ?? null;
};
